export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
  IRRELEVANT: 'irrelevant',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 1,
  high: 2,
  medium: 3,
  low: 4,
  null: 5,
};

// Size in mega bytes
export const MAXIMUM_FILE_UPLOAD_SIZE = 40;
export const MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL = 5;
// Stays below Gmail/Outlook's ~25 MB inbound cap after base64 overhead.
export const MAXIMUM_FILE_UPLOAD_SIZE_EMAIL_CHANNEL = 20;

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const ALLOWED_FILE_TYPES_FOR_TWILIO_WHATSAPP =
  'image/png, image/jpeg,' +
  'audio/mpeg, audio/opus, audio/ogg, audio/amr,' +
  'video/mp4,' +
  'application/pdf,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  WAV: 'audio/wav',
};

export const MESSAGE_VARIABLES = [
  {
    label: 'Conversation Id',
    key: 'conversation.id',
  },
  {
    label: 'Conversation created at',
    key: 'conversation.created_at',
  },
  {
    label: 'Conversation assignee',
    key: 'conversation.assignee',
  },
  {
    label: 'Conversation assignee username',
    key: 'conversation.assignee_username',
  },
  {
    label: 'Conversation Meet Link',
    key: 'conversation.meet_link',
  },
  {
    label: 'Conversation Reminder Note',
    key: 'conversation.reminder_note',
  },
  {
    label: 'Conversation Meeting Time',
    key: 'conversation.meeting_timings',
  },
  {
  label: 'Conversation Demo Meeting Time',
    key: 'conversation.demo_meet_timing',
  },
  {
    label: 'Contact Id',
    key: 'contact.id',
  },
  {
    label: 'Contact created at',
    key: 'contact.created_at',
  },
  {
    label: 'Contact assignee',
    key: 'contact.assignee',
  },
  {
    label: 'Contact assignee username',
    key: 'contact.assignee_username',
  },
  {
    label: 'Contact name',
    key: 'contact.name',
  },
  {
    label: 'Contact first name',
    key: 'contact.first_name',
  },
  {
    label: 'Contact last name',
    key: 'contact.last_name',
  },
  {
    label: 'Contact email',
    key: 'contact.email',
  },
  {
    label: 'Contact phone',
    key: 'contact.phone',
  },
  {
    label: 'Agent name',
    key: 'agent.name',
  },
  {
    label: 'Agent first name',
    key: 'agent.first_name',
  },
  {
    label: 'Agent last name',
    key: 'agent.last_name',
  },
  {
    label: 'Agent email',
    key: 'agent.email',
  },
  {
    label: 'Agent Kivo Chat username',
    key: 'agent.kivo_chat_username',
  },
  {
    label: 'Contact Meeting Time',
    key: 'contact.meeting_timing',
  },
  {
    label: 'Contact Meeting Date & Time',
    key: 'contact.meeting_date_timing',
  },
  {
    label: 'Contact Demo Subject',
    key: 'contact.demo_subject',
  },
  {
    label: 'Contact Demo Meeting Link',
    key: 'contact.demo_meeting_link',
  },
  {
    label: 'Available meeting participants (all names)',
    key: 'contact.available_participants',
  },
  {
    label: 'Available participant 1',
    key: 'contact.available_participant_1',
  },
  {
    label: 'Available participant 2',
    key: 'contact.available_participant_2',
  },
  {
    label: 'Available participant 3',
    key: 'contact.available_participant_3',
  },
  {
    label: 'Available participant 4',
    key: 'contact.available_participant_4',
  },
  {
    label: 'Available participant 5',
    key: 'contact.available_participant_5',
  },
  {
    label: 'Joined guest name',
    key: 'contact.joined_guest_name',
  },
  {
    label: 'Joined guest email',
    key: 'contact.joined_guest_email',
  },
  {
    label: 'First joining time',
    key: 'contact.first_joining_time',
  },
  {
    label: 'All joined guests',
    key: 'contact.all_joined_guests',
  },
  {
    label: 'Account ID',
    key: 'account.id',
  },
  {
    label: 'Inbox Type',
    key: 'inbox.type',
  },
  {
    label: 'Contact Labels',
    key: 'contact.labels',
  },
  {
    label: 'Conversation Labels',
    key: 'conversation.labels',
  },
  {
    label: 'Conversation Messages',
    key: 'conversation.messages',
  },
  {
    label: 'Message created at',
    key: 'message.created_at',
  },
];
